import { BaseQueryFn, MutationDefinition } from "@reduxjs/toolkit/dist/query";
import { MutationTrigger } from "@reduxjs/toolkit/dist/query/react/buildHooks";
import { useAppDispatch } from "./store";
import { useTranslation } from "react-i18next";
import { useCallback, useState } from "react";
import { showNotification } from "../store/reducers";
import { IMessageResponse } from "../shared";

type IHandleActivate<
  ApiName extends string,
  TResponse = IMessageResponse,
> = MutationTrigger<
  MutationDefinition<
    string,
    BaseQueryFn<
      {
        url: string;
        method: string | undefined;
        data?: any;
        params?: any;
      },
      unknown,
      unknown
    >,
    ApiName,
    TResponse,
    ApiName
  >
>;
export const useHandleActivate = <
  ApiName extends string,
  TResponse = IMessageResponse,
>(
  handleActivate: IHandleActivate<ApiName, TResponse>,
) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [isActivateConfirmOpen, setIsActivateConfirmOpen] = useState(false);
  const [id, setId] = useState<string>("");

  const handleConfirmActivate = async () => {
    try {
      await handleActivate(id).unwrap();
      setIsActivateConfirmOpen(false);
      dispatch(
        showNotification({
          type: "success",
          message: t("alert.successfulActivation"),
        }),
      );
    } catch (error: any) {
      dispatch(
        showNotification({
          type: "error",
          message: t("alert.somethingWentWrong"),
        }),
      );
    }
  };

  const handleCancelActivate = () => {
    setIsActivateConfirmOpen(false);
  };

  const onActivate = useCallback((id: string) => {
    setId(id);
    setIsActivateConfirmOpen(true);
  }, []);

  return {
    isActivateConfirmOpen,
    handleConfirmActivate,
    handleCancelActivate,
    onActivate,
  };
};
